import gql from "graphql-tag";

export const CREATE_MY_TIME_SHEET_MESSAGE = gql`
  mutation createMyTimesheetMessage($request: String!, $message: String!) {
    createMyTimesheetMessage(request: $request, message: $message) {
      _id
      request
      message
      createdAt
      createdBy
    }
  }
`;
